import React, { useEffect, useState } from "react";
import axios from "axios";
import { getNews } from "./Transformations/NewsList";

export default function News() {
	const [newsData, setNewsData] = useState([]);

	useEffect(() => {
		const fetchData = async () => {
			const data = await getNews();

			setNewsData(data);
		};

		fetchData();
	}, []);

	return (
		<div>
			<h2>News</h2>
			{newsData.map((newsItem, index) => (
				<div key={index}>
					<h3>{newsItem.news_heading}</h3>
					<span>{newsItem.news_body}</span>
				</div>
			))}
		</div>
	);
}
